/* --------------------------------------------------------------------------------------
   xwActivity.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

import { useRef, useEffect } from 'preact/hooks'

const XwActivity = props => {
  const elementRef = useRef(null)
  const elementId = `act-${new Date().getTime()}`
  const completeActivity = () =>
    {
          return $(elementRef.current).xrxactivityindicator('complete')
      }
  useEffect(() => {
    $(elementRef.current).xrxactivityindicator(props)
    return () => safeDestroy()
  }, [])
  useEffect(
    () => (props.completed ? setTimeout(() => completeActivity(), 500) : null),
    [props.completed]
  )
  return <div ref={elementRef} id={elementId} />
}

const safeDestroy = () => {
  try {
    $(elementRef.current).xrxactivityindicator('destroy')
  } catch (e) {}
}

export default XwActivity
